import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import AddMoreIcon from "../../../assets/icons/add-more.svg";
import { Flex } from "../../../components/Table/table.styled";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import PlaceIcon from "@mui/icons-material/Place";
import NavBar from "../../../components/navbar/navbar.component";
import { Container } from "./orders.styled";
import { Heading } from "../../../components/Tags/tags.styled";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from "react-toastify";
import { userObj } from "../../../helper/protectedRoutes";
import { getCities } from "../../../app/features/Customer/getCitiesSlice";
import { getTowns } from "../../../app/features/Customer/getTownsSlice";
import { suggestAddr } from "../../../app/features/Customer/Order/suggestAddressSlice";
import { getPlaceId } from "../../../app/features/Customer/Order/placeIdSlice";
import { calculatePrice } from "../../../app/features/Customer/Order/calculatePaymentSlice";
import { trackOrder } from "../../../app/features/Customer/Order/trackingOrderSlice";
import {
  getOrder,
  getOrderId,
} from "../../../app/features/Customer/Order/getOrderSlice";
import { updateShipment } from "../../../app/features/Customer/Order/updateShipmentSlice";

const dollarUSLocale = Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatMoney = (value) => "₦" + dollarUSLocale.format(Number(value) || 0);

const strikeThrough = {
  fontSize: "13px",
  color: "#9e9e9e",
  textDecoration: "line-through",
  marginRight: "8px",
};

const PackageScheduleEditPage = () => {
  const dispatch = useDispatch();
  const user = userObj?.extra;
  const navigate = useNavigate();
  const { no } = useParams();

  const init_packagePayload = {
    senderName: "",
    name: "",
    phoneNumber: "",
    email: "",
    recipientAddress: "",
    postalCode: "",
    city: null,
    townId: null,
    originId: null,
    originTownId: null,
    flyerNo: "",
    pickup: "",
    pickupLocModel: null,
    unit: 0,
    unitWeight: 0,
    weight: 0,
    description: "",
    declaredValue: 0,
    insured: false,
    cashonDelivery: 0,
  };

  const [cities, setCities] = React.useState([]);
  const [originCities, setOriginCities] = React.useState([]);
  const [city, setCity] = React.useState(null);
  const [towns, setTowns] = React.useState([]);
  const [originTowns, setOriginTowns] = React.useState([]);
  const [pickup, setPickup] = React.useState([]);
  const [pickupInput, setPickupInput] = React.useState();
  const [selectedPickup, setSelectedPickup] = React.useState("");
  const [destInput, setDestInput] = React.useState();
  const [destination, setDestination] = React.useState([]);
  const [selectedDest, setSelectedDest] = React.useState("");
  const [cashOption, setCashOption] = React.useState("no");
  const [priceData, setPriceData] = React.useState({});
  const [shipment, setShipment] = React.useState(null);
  const [orderId, setOrderId] = React.useState(null);
  const [isLoadingPage, setIsLoadingPage] = React.useState(true);
  const [openSummary, setOpenSummary] = React.useState(false);
  const [packagingType, setPackagingType] = React.useState("normal");
  const [calculatePricePayload, setCalculatePricePayload] =
    React.useState(init_packagePayload);
  const [newPackage, setNewPackage] = React.useState({
    description: "",
    commodity: "",
    quantity: 0,
    weight: 0,
    unitOfPrice: 0,
  });
  const [additionalPackage, setAdditionalPackage] = React.useState([]);

  const { isCalculating } = useSelector((state) => state.calculatedPrice);
  const { isUpdatingShipment } = useSelector((state) => state.updateShipment);

  const oldPayment = shipment?.shipmentPayment ? shipment.shipmentPayment : {};
  const newPayment = priceData?.shipment?.shipmentPayment
    ? priceData.shipment.shipmentPayment
    : {};
  const hasNewPrice = Boolean(priceData?.orderPrice);
  const oldAmount = Number(oldPayment?.totalAmount || 0);
  const currentAmount = hasNewPrice
    ? Number(priceData?.orderPrice?.maxValue || 0)
    : oldAmount;
  const isAmountChanged = hasNewPrice && oldAmount !== currentAmount;

  useEffect(() => {
    document.title = "Edit Scheduled Package - Customer";
    dispatch(getCities()).then((res) => {
      const { payload } = res;
      if (payload) {
        setCities(payload);
        setOriginCities(payload);
      }
    });
    if (no) {
      dispatch(getOrderId(no)).then((res) => {
        const { payload, error } = res;
        const resolvedOrderId = error ? null : payload;
        setOrderId(resolvedOrderId);
        dispatch(trackOrder(no)).then((trackedRes) => {
          const { payload: trackedShipment, error: trackingError } = trackedRes;
          setIsLoadingPage(false);
          if (trackingError || !trackedShipment) {
            toast.error("We could not load this order for editing");
            return;
          }
          if (trackedShipment.id && trackedShipment.cityId) {
            hydrateForm(trackedShipment);
          } else {
            fillMissingShipmentIds(resolvedOrderId, trackedShipment);
          }
        });
      });
    } else {
      setIsLoadingPage(false);
    }
  }, []);

  useEffect(() => {
    if (additionalPackage.length > 0) {
      handleChangeInValues();
    }
  }, [additionalPackage]);

  const fillMissingShipmentIds = (resolvedOrderId, trackedShipment) => {
    if (!resolvedOrderId) {
      hydrateForm(trackedShipment);
      return;
    }
    dispatch(getOrder(resolvedOrderId)).then((res) => {
      const { payload, error } = res;
      const orderShipment = payload?.shipment;
      if (error || !orderShipment) {
        hydrateForm(trackedShipment);
        return;
      }
      hydrateForm({
        ...orderShipment,
        ...trackedShipment,
        id: orderShipment.id ?? trackedShipment.id,
        recipientId: orderShipment.recipientId ?? trackedShipment.recipientId,
        sbuId: orderShipment.sbuId ?? trackedShipment.sbuId,
        cityId: orderShipment.cityId ?? trackedShipment.cityId,
        townId: orderShipment.townId ?? trackedShipment.townId,
        originId: orderShipment.originId ?? trackedShipment.originId,
        originTownId: orderShipment.originTownId ?? trackedShipment.originTownId,
        senderAccountNo:
          orderShipment.senderAccountNo ?? trackedShipment.senderAccountNo,
        pickupLocModel:
          orderShipment.pickupLocModel ?? trackedShipment.pickupLocModel,
        recipient: {
          ...(orderShipment.recipient ?? {}),
          ...(trackedShipment.recipient ?? {}),
        },
        shipmentPayment: {
          ...(orderShipment.shipmentPayment ?? {}),
          ...(trackedShipment.shipmentPayment ?? {}),
        },
      });
    });
  };

  const hydrateForm = (loadedShipment) => {
    const payment = loadedShipment.shipmentPayment
      ? loadedShipment.shipmentPayment
      : {};
    const recipient = loadedShipment.recipient
      ? loadedShipment.recipient
      : {};
    const loadedPackages =
      loadedShipment.commercialDetails &&
      loadedShipment.commercialDetails.length > 0
        ? loadedShipment.commercialDetails.map((item) => ({
            description: item.description ? item.description : "",
            commodity: item.commodity ? item.commodity : "",
            quantity: item.quantity ? item.quantity : 0,
            weight: item.weight ? item.weight : 0,
            unitOfPrice: item.unitOfPrice ? item.unitOfPrice : 0,
          }))
        : [
            {
              description: loadedShipment.contentDescription
                ? loadedShipment.contentDescription
                : "",
              commodity: loadedShipment.contentDescription
                ? loadedShipment.contentDescription
                : "",
              quantity: loadedShipment.unit ? loadedShipment.unit : 0,
              weight: loadedShipment.weight ? loadedShipment.weight : 0,
              unitOfPrice: payment.declaredValue ? payment.declaredValue : 0,
            },
          ];

    setShipment(loadedShipment);
    setCity(loadedShipment.city ? loadedShipment.city : null);
    setPackagingType(
      loadedShipment.packaging === "Dimensional Box" ? "dimensional" : "normal",
    );
    setCashOption(Number(payment.cashonDelivery) > 0 ? "yes" : "no");
    setSelectedPickup(
      loadedShipment.senderAddress ? loadedShipment.senderAddress : "",
    );
    setSelectedDest(recipient.streetAddress ? recipient.streetAddress : "");
    setAdditionalPackage(loadedPackages);
    setCalculatePricePayload({
      senderName: loadedShipment.senderName ? loadedShipment.senderName : "",
      name: recipient.recipientName ? recipient.recipientName : "",
      phoneNumber: recipient.phoneNumber ? recipient.phoneNumber : "",
      email: recipient.email ? recipient.email : "",
      recipientAddress: recipient.streetAddress ? recipient.streetAddress : "",
      postalCode: recipient.postalCode ? recipient.postalCode : "",
      city: loadedShipment.cityId ? loadedShipment.cityId : null,
      townId: loadedShipment.townId ? loadedShipment.townId : null,
      originId: loadedShipment.originId ? loadedShipment.originId : null,
      originTownId: loadedShipment.originTownId
        ? loadedShipment.originTownId
        : null,
      flyerNo: loadedShipment.flyerNo ? loadedShipment.flyerNo : "",
      pickup: loadedShipment.senderAddress ? loadedShipment.senderAddress : "",
      pickupLocModel: loadedShipment.pickupLocModel
        ? loadedShipment.pickupLocModel
        : null,
      unit: loadedShipment.unit ? loadedShipment.unit : 0,
      unitWeight: loadedShipment.weight ? loadedShipment.weight : 0,
      weight: loadedShipment.weight ? loadedShipment.weight : 0,
      description: loadedShipment.contentDescription
        ? loadedShipment.contentDescription
        : "",
      declaredValue: payment.declaredValue ? payment.declaredValue : 0,
      insured: loadedShipment.insured,
      cashonDelivery: payment.cashonDelivery ? payment.cashonDelivery : 0,
    });
    if (loadedShipment.originId) {
      loadTowns(loadedShipment.originId, setOriginTowns);
    }
    if (loadedShipment.cityId) {
      loadTowns(loadedShipment.cityId, setTowns);
    }
  };

  const loadTowns = (id, setTownList) => {
    dispatch(getTowns(id)).then((res) => {
      const { payload } = res;
      if (!payload) {
        return;
      }
      const sortedTowns = [...payload].sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      setTownList(sortedTowns);
    });
  };

  const handleCityChange = (e) => {
    const { name, value } = e.target;
    setCalculatePricePayload({
      ...calculatePricePayload,
      [name]: value,
    });
    const selectedCity = cities.find((c) => c.id === value);
    setCity(selectedCity ? selectedCity : null);
    loadTowns(value, setTowns);
  };
  const handleOriginChange = (e) => {
    const { name, value } = e.target;
    setCalculatePricePayload({
      ...calculatePricePayload,
      [name]: value,
    });
    loadTowns(value, setOriginTowns);
  };
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setCalculatePricePayload({
      ...calculatePricePayload,
      [name]: value,
    });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCalculatePricePayload({
      ...calculatePricePayload,
      [name]: value,
    });
  };
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setNewPackage({
      ...newPackage,
      [name]: value,
    });
  };

  const handleSuggestPickupAddress = (e) => {
    const { value } = e.target;
    setPickupInput(value?.length);
    setSelectedPickup(value);
    setCalculatePricePayload({
      ...calculatePricePayload,
      pickup: value,
    });
    if (value?.length > 5) {
      dispatch(suggestAddr(value)).then((res) => {
        const { error, payload } = res;
        if (!error) {
          setPickup(payload);
        }
      });
    }
  };
  const handleSuggestAddress = (e) => {
    const { value } = e.target;
    setDestInput(value?.length);
    setPickup([]);
    setSelectedDest(value);
    setCalculatePricePayload({
      ...calculatePricePayload,
      recipientAddress: value,
    });
    if (value?.length > 5) {
      dispatch(suggestAddr(value)).then((res) => {
        const { error, payload } = res;
        if (!error) {
          setDestination(payload);
        }
      });
    }
  };

  const handlePickupSelect = (p) => {
    dispatch(getPlaceId(p?.place_id)).then((res) => {
      const { payload, error } = res;
      if (!error) {
        setSelectedPickup(payload?.formatted_address);
        setCalculatePricePayload({
          ...calculatePricePayload,
          pickup: payload?.formatted_address,
          pickupLocModel: {
            longitude: payload?.geometry.location["lng"],
            latitude: payload?.geometry.location["lat"],
          },
        });
      }
    });

    setPickup([]);
  };
  const handleDestSelect = (d) => {
    dispatch(getPlaceId(d?.place_id)).then((res) => {
      const { payload, error } = res;
      if (!error) {
        setSelectedDest(payload?.formatted_address);
        setCalculatePricePayload({
          ...calculatePricePayload,
          recipientAddress: payload?.formatted_address,
        });
      }
    });

    setDestination([]);
  };

  const handleUnitChange = (e) => {
    const { name, value } = e.target;
    const unit = value;
    if (unit > 0 && calculatePricePayload.unitWeight > 0) {
      const totalWeight = calculatePricePayload.unitWeight * unit;
      setCalculatePricePayload({
        ...calculatePricePayload,
        unit: value,
        weight: totalWeight,
      });
    } else {
      setCalculatePricePayload({
        ...calculatePricePayload,
        [name]: value,
      });
    }
  };
  const handleWeightChange = (e) => {
    const { name, value } = e.target;
    const weight = value;
    if (weight > 0 && calculatePricePayload.unit > 0) {
      const totalWeight = calculatePricePayload.unit * weight;
      setCalculatePricePayload({
        ...calculatePricePayload,
        unitWeight: value,
        weight: totalWeight,
      });
    } else {
      setCalculatePricePayload({
        ...calculatePricePayload,
        [name]: value,
      });
    }
  };

  const handleSummaryOpen = () => {
    setOpenSummary(true);
  };
  const handleSummaryClose = () => {
    setOpenSummary(false);
  };

  const getTotalValue = (items) => {
    let sum = 0;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        sum += Number(items[i].unitOfPrice);
      }
    }
    return sum;
  };

  const getDescription = (items) => {
    let sum = "";
    if (items) {
      for (let i = 0; i < items.length; i++) {
        sum += " " + items[i].description;
      }
    }
    return sum;
  };

  const getTotalWeight = (items) => {
    let sum = 0;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        sum += Number(items[i].weight);
      }
    }
    return sum;
  };

  const handleChangeInValues = () => {
    var ad = additionalPackage;
    var values = getTotalValue(ad);
    var weights = getTotalWeight(ad);
    var des = getDescription(ad);
    setCalculatePricePayload({
      ...calculatePricePayload,
      declaredValue: values,
      weight: weights,
      unitWeight: weights,
      description: des,
    });
  };

  const handleAdditionalPackage = () => {
    var req = newPackage;
    if (additionalPackage.length === 0) {
      var d = [];
      d.push(req);
      setAdditionalPackage(d);
    } else {
      setAdditionalPackage((p) => [...p, req]);
    }
    setNewPackage({
      description: "",
      commodity: "",
      quantity: 0,
      weight: 0,
      unitOfPrice: 0,
    });
  };
  const removeAdditionalPackage = (index) => {
    setAdditionalPackage((packages) =>
      packages.filter((item, itemIndex) => itemIndex !== index),
    );
  };

  const getRecipientCity = () => {
    if (city?.name) {
      return city.name;
    }
    if (shipment?.city?.name) {
      return shipment.city.name;
    }
    return "";
  };

  const appendIfPresent = (form, key, value) => {
    if (value === null || value === undefined || value === "") {
      return;
    }
    form.append(key, value);
  };

  const buildPriceFormData = () => {
    const form = new FormData();
    const pickupLoc = calculatePricePayload.pickupLocModel;
    form.append("CustomerId", user?.id);
    form.append("VehicleTypeId", 8);
    form.append("VehicleSizeId", 9);
    form.append("Pickup", calculatePricePayload.pickup);
    form.append(
      "PickupLocModel.Longitude",
      !pickupLoc ? 0.0 : pickupLoc.longitude,
    );
    form.append("PickupLocModel.Latitude", !pickupLoc ? 0.0 : pickupLoc.latitude);
    form.append(
      "Shipment.SenderAccountNo",
      shipment?.senderAccountNo ? shipment.senderAccountNo : user?.wallet?.id,
    );
    form.append(
      "Shipment.SenderName",
      calculatePricePayload.senderName ? calculatePricePayload.senderName : "",
    );
    form.append("Shipment.SenderAddress", calculatePricePayload.pickup);
    form.append("Type", 1);
    form.append("Shipment.SBUId", shipment?.sbuId ? shipment.sbuId : 5);
    appendIfPresent(form, "Shipment.OriginId", calculatePricePayload.originId);
    appendIfPresent(form, "Shipment.CityId", calculatePricePayload.city);
    appendIfPresent(form, "Shipment.TownId", calculatePricePayload.townId);
    form.append(
      "Shipment.ContentDescription",
      calculatePricePayload.description,
    );
    form.append("Shipment.Weight", calculatePricePayload.weight);
    form.append("Shipment.Unit", calculatePricePayload.unit);
    form.append("Shipment.Insured", calculatePricePayload.insured);
    appendIfPresent(
      form,
      "Shipment.OriginTownId",
      calculatePricePayload.originTownId,
    );
    form.append(
      "Shipment.Recipient.Email",
      calculatePricePayload.email === undefined
        ? ""
        : calculatePricePayload.email,
    );
    form.append("Shipment.Recipient.RecipientName", calculatePricePayload.name);
    form.append(
      "Shipment.Recipient.PhoneNumber",
      calculatePricePayload.phoneNumber,
    );
    form.append(
      "Shipment.Recipient.StreetAddress",
      calculatePricePayload.recipientAddress,
    );
    form.append("Shipment.Recipient.City", getRecipientCity());
    form.append(
      "Shipment.Recipient.PostalCode",
      calculatePricePayload.postalCode === undefined
        ? ""
        : calculatePricePayload.postalCode,
    );
    form.append(
      "Shipment.ShipmentPayment.DeclaredValue",
      calculatePricePayload.declaredValue === undefined
        ? 0
        : calculatePricePayload.declaredValue,
    );
    form.append(
      "Shipment.ShipmentPayment.CashonDelivery",
      calculatePricePayload.cashonDelivery
        ? calculatePricePayload.cashonDelivery
        : 0,
    );
    additionalPackage.forEach((item, index) => {
      form.append(
        `Shipment.CommercialDetails[${index}].Description`,
        item.description,
      );
      form.append(
        `Shipment.CommercialDetails[${index}].Commodity`,
        item.commodity ? item.commodity : item.description,
      );
      form.append(`Shipment.CommercialDetails[${index}].Weight`, item.weight);
      form.append(
        `Shipment.CommercialDetails[${index}].Quantity`,
        item.quantity,
      );
      form.append(
        `Shipment.CommercialDetails[${index}].UnitOfPrice`,
        item.unitOfPrice,
      );
    });
    return form;
  };

  const handlePriceCalculate = () => {
    if (additionalPackage.length === 0) {
      toast.error("You must add package by using Add New Package Button");
      return;
    }
    if (calculatePricePayload.description === "") {
      toast.error("Content Description cannot be empty");
      return;
    }
    if (calculatePricePayload.unit === 0) {
      toast.error("Number of Package cannot be zero");
      return;
    }
    if (
      calculatePricePayload.insured === undefined ||
      calculatePricePayload.insured === null
    ) {
      toast.error("Insurance cannot be empty");
      return;
    }
    if (!calculatePricePayload.city || !calculatePricePayload.originId) {
      toast.error("Origin and Destination City are required");
      return;
    }

    if (
      calculatePricePayload.declaredValue > 100000 &&
      !calculatePricePayload.insured
    ) {
      const userConfirmation = window.confirm(
        "Kindly note that this shipment is not insured. If the item is damaged during delivery, Red Star Express will only be able to refund a maximum of ₦100,000, regardless of the item's actual value. Do you wish to proceed with the shipment?",
      );
      if (!userConfirmation) {
        return;
      }
    }

    dispatch(calculatePrice(buildPriceFormData())).then((res) => {
      const { payload, error } = res;
      if (!error) {
        setPriceData(payload);
        handleSummaryOpen();
      } else {
        toast.error(payload);
      }
    });
  };

  const buildShipmentPayload = () => {
    const payment = shipment?.shipmentPayment ? shipment.shipmentPayment : {};
    const recipient = shipment?.recipient ? shipment.recipient : {};

    return {
      ...shipment,
      senderName: calculatePricePayload.senderName,
      senderAddress: calculatePricePayload.pickup,
      flyerNo: calculatePricePayload.flyerNo ? calculatePricePayload.flyerNo : "",
      contentDescription: calculatePricePayload.description,
      weight: Number(calculatePricePayload.weight) || 0,
      unit: Number(calculatePricePayload.unit) || 0,
      insured: calculatePricePayload.insured === true,
      cityId: calculatePricePayload.city,
      townId: calculatePricePayload.townId,
      originId: calculatePricePayload.originId,
      originTownId: calculatePricePayload.originTownId,
      orderId: orderId,
      recipient: {
        ...recipient,
        recipientName: calculatePricePayload.name,
        phoneNumber: calculatePricePayload.phoneNumber,
        email: calculatePricePayload.email ? calculatePricePayload.email : "",
        streetAddress: calculatePricePayload.recipientAddress,
        postalCode: calculatePricePayload.postalCode
          ? calculatePricePayload.postalCode
          : "",
        city: getRecipientCity(),
      },
      commercialDetails: additionalPackage.map((item, index) => {
        const existingDetail = shipment?.commercialDetails?.[index]
          ? shipment.commercialDetails[index]
          : {};
        return {
          ...existingDetail,
          description: item.description,
          commodity: item.commodity ? item.commodity : item.description,
          weight: Number(item.weight) || 0,
          quantity: Number(item.quantity) || 0,
          unitOfPrice: Number(item.unitOfPrice) || 0,
        };
      }),
      shipmentPayment: {
        ...payment,
        servicePrice: newPayment.servicePrice ?? payment.servicePrice,
        onforwardingCharge:
          newPayment.onforwardingCharge ?? payment.onforwardingCharge,
        insuranceValue: newPayment.insuranceValue ?? payment.insuranceValue,
        cratingValue: newPayment.cratingValue ?? payment.cratingValue,
        additionalCharge:
          newPayment.additionalCharge ?? payment.additionalCharge,
        discount: newPayment.discount ?? payment.discount,
        vat: newPayment.vat ?? payment.vat,
        declaredValue: calculatePricePayload.declaredValue
          ? calculatePricePayload.declaredValue
          : 0,
        cashonDelivery: Number(calculatePricePayload.cashonDelivery) || 0,
        totalAmount:
          hasNewPrice && priceData?.orderPrice?.maxValue !== undefined
            ? priceData.orderPrice.maxValue
            : payment.totalAmount,
        paidAmount: payment.paidAmount,
      },
    };
  };

  const handleSave = () => {
    if (!shipment) {
      return;
    }
    dispatch(updateShipment(buildShipmentPayload())).then((res) => {
      const { error, payload } = res;
      if (!error) {
        toast.success("Shipment updated successfully");
        setOpenSummary(false);
        navigate("/dashboard/customer");
      } else {
        toast.error(payload);
      }
    });
  };

  const renderPriceLine = (label, oldValue, newValue) => {
    const currentValue = hasNewPrice ? (newValue ?? oldValue) : oldValue;
    const isChanged =
      hasNewPrice && Number(oldValue || 0) !== Number(currentValue || 0);

    return (
      <div className="" key={label}>
        <span style={{ fontSize: "12px" }}>{label}</span>
        <p style={{ fontSize: "16px", fontWeight: "500" }} className="">
          {isChanged && <span style={strikeThrough}>{formatMoney(oldValue)}</span>}
          {formatMoney(currentValue)}
        </p>
      </div>
    );
  };

  return (
    <>
      <NavBar />
      <div className="main-content main-content-margin-top">
        <Container>
          <Heading size="1.8rem">Edit Scheduled Package</Heading>
          {shipment && (
            <p className="page-subl-title fw-bold">
              {shipment.waybillNumber}
              {shipment.createdOn
                ? " - " + new Date(shipment.createdOn).toLocaleDateString()
                : ""}
            </p>
          )}

          {isLoadingPage ? (
            <Flex
              style={{
                justifyContent: "center",
                marginTop: "40px",
                marginBottom: "40px",
              }}
            >
              <CircularProgress />
            </Flex>
          ) : !shipment ? (
            <Card variant="outlined">
              <CardContent>
                <p className="text-Center">
                  This order could not be loaded for editing. Return to the
                  dashboard and try again.
                </p>
              </CardContent>
            </Card>
          ) : (
            <>
              <Card
                sx={{
                  marginBottom: "12px",
                }}
                variant="outlined"
              >
                <CardContent>
                  <Box sx={{ m: 1 }}>
                    <Heading size="1.2rem">Pickup Information</Heading>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    <div className="">
                      <TextField
                        fullWidth
                        sx={{ m: 1 }}
                        label="Pickup Address"
                        id="outlined-size-small"
                        value={selectedPickup}
                        size="small"
                        onChange={(e) => handleSuggestPickupAddress(e)}
                      />
                      {pickupInput > 5 && (
                        <nav aria-label="secondary mailbox folders">
                          <List>
                            {pickup.map((row) => {
                              return (
                                <ListItem disablePadding>
                                  <ListItemButton
                                    onClick={() => handlePickupSelect(row)}
                                  >
                                    <PlaceIcon style={{ marginRight: "10px" }} />
                                    <ListItemText
                                      primary={`${row?.description}`}
                                    />
                                  </ListItemButton>
                                </ListItem>
                              );
                            })}
                          </List>
                        </nav>
                      )}
                      <FormControl sx={{ m: 1, width: "50ch" }} size="small">
                        <InputLabel id="origin-city-label">
                          Origin City
                        </InputLabel>
                        <Select
                          labelId="origin-city-label"
                          id="origin-city-select"
                          name="originId"
                          value={calculatePricePayload.originId}
                          label="Origin City"
                          onChange={(e) => handleOriginChange(e)}
                        >
                          <MenuItem value={null}>
                            <em>-- Select --</em>
                          </MenuItem>
                          {originCities?.map((c, key) => (
                            <MenuItem value={c.id} key={key}>
                              {c.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl sx={{ m: 1, width: "50ch" }} size="small">
                        <InputLabel id="origin-town-label">
                          Origin Town
                        </InputLabel>
                        <Select
                          labelId="origin-town-label"
                          id="origin-town-select"
                          name="originTownId"
                          value={calculatePricePayload.originTownId}
                          label="Origin Town"
                          onChange={(e) => handleSelectChange(e)}
                        >
                          <MenuItem value={null}>
                            <em>-- Select --</em>
                          </MenuItem>
                          {originTowns?.map((t, key) => (
                            <MenuItem value={t.id} key={key}>
                              {t.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl sx={{ width: "50ch" }} size="small">
                        <TextField
                          sx={{ m: 1, width: "50ch" }}
                          label="Sender Name"
                          id="outlined-size-small"
                          name="senderName"
                          value={calculatePricePayload.senderName}
                          size="small"
                          onChange={(e) => handleInputChange(e)}
                        />
                      </FormControl>
                    </div>
                  </Box>
                </CardContent>
              </Card>

              <Card
                sx={{
                  marginBottom: "12px",
                }}
                variant="outlined"
              >
                <CardContent>
                  <Box sx={{ m: 1 }}>
                    <Heading size="1.2rem">Recipient Information</Heading>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    <div className="">
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Name"
                        id="outlined-size-small"
                        name="name"
                        value={calculatePricePayload.name}
                        size="small"
                        onChange={(e) => handleInputChange(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Phone Number"
                        id="outlined-size-small"
                        name="phoneNumber"
                        value={calculatePricePayload.phoneNumber}
                        size="small"
                        onChange={(e) => handleInputChange(e)}
                      />
                      <TextField
                        fullWidth
                        sx={{ m: 1 }}
                        label="Delivery Address"
                        id="outlined-size-small"
                        value={selectedDest}
                        size="small"
                        onChange={(e) => handleSuggestAddress(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "25ch" }}
                        label="Landmark"
                        id="outlined-size-small"
                        value={calculatePricePayload.postalCode}
                        name="postalCode"
                        size="small"
                        onChange={(e) => handleInputChange(e)}
                      />
                      {destInput > 5 && (
                        <nav aria-label="secondary mailbox folders">
                          <List>
                            {destination.map((row) => {
                              return (
                                <ListItem disablePadding>
                                  <ListItemButton
                                    onClick={() => handleDestSelect(row)}
                                  >
                                    <PlaceIcon style={{ marginRight: "10px" }} />
                                    <ListItemText
                                      primary={`${row?.description}`}
                                    />
                                  </ListItemButton>
                                </ListItem>
                              );
                            })}
                          </List>
                        </nav>
                      )}
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Email"
                        id="outlined-size-small"
                        name="email"
                        value={calculatePricePayload.email}
                        size="small"
                        onChange={(e) => handleInputChange(e)}
                      />

                      <FormControl sx={{ m: 1, width: "25ch" }} size="small">
                        <InputLabel id="city-label">City</InputLabel>
                        <Select
                          labelId="city-label"
                          id="city-select"
                          name="city"
                          value={calculatePricePayload.city}
                          label="City"
                          onChange={(e) => handleCityChange(e)}
                        >
                          <MenuItem value={null}>
                            <em>-- Select --</em>
                          </MenuItem>
                          {cities?.map((c, key) => (
                            <MenuItem value={c.id} key={key}>
                              {c.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl sx={{ m: 1, width: "25ch" }} size="small">
                        <InputLabel id="town-label">Town</InputLabel>
                        <Select
                          labelId="town-label"
                          id="town-select"
                          name="townId"
                          value={calculatePricePayload.townId}
                          label="Town"
                          onChange={(e) => handleSelectChange(e)}
                        >
                          <MenuItem value={null}>
                            <em>-- Select --</em>
                          </MenuItem>
                          {towns?.map((t, key) => (
                            <MenuItem value={t.id} key={key}>
                              {t.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </Box>
                </CardContent>
              </Card>

              <Card
                sx={{
                  marginBottom: "12px",
                }}
                variant="outlined"
              >
                <CardContent>
                  <Box sx={{ m: 1 }}>
                    <Heading size="1.2rem">Package Information</Heading>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <FormControl sx={{ m: 1, width: "25ch" }} size="small">
                          <InputLabel id="packaging-type-label">
                            Package Type
                          </InputLabel>
                          <Select
                            labelId="packaging-type-label"
                            id="packaging-type-select"
                            value={packagingType}
                            label="Package Type"
                            onChange={(e) => {
                              setPackagingType(e.target.value);
                              if (e.target.value === "normal") {
                                setNewPackage({
                                  ...newPackage,
                                  length: "",
                                  width: "",
                                  height: "",
                                });
                              }
                            }}
                          >
                            <MenuItem value="normal">Normal</MenuItem>
                            <MenuItem value="dimensional">
                              Dimensional Weight
                            </MenuItem>
                          </Select>
                        </FormControl>

                        {packagingType === "dimensional" && (
                          <>
                            <TextField
                              sx={{ m: 1, width: "20ch" }}
                              label="Length"
                              name="length"
                              value={newPackage.length}
                              size="small"
                              type="number"
                              onChange={(e) => handleAddChange(e)}
                            />
                            <TextField
                              sx={{ m: 1, width: "20ch" }}
                              label="Width"
                              name="width"
                              value={newPackage.width}
                              size="small"
                              type="number"
                              onChange={(e) => handleAddChange(e)}
                            />
                            <TextField
                              sx={{ m: 1, width: "20ch" }}
                              label="Height"
                              name="height"
                              value={newPackage.height}
                              size="small"
                              type="number"
                              onChange={(e) => handleAddChange(e)}
                            />
                            <Button
                              sx={{ m: 1 }}
                              variant="outlined"
                              size="small"
                              onClick={() => {
                                const { length, width, height } = newPackage;
                                if (length && width && height) {
                                  const weight = (length * width * height) / 5000;
                                  setNewPackage((prev) => ({ ...prev, weight }));
                                  setCalculatePricePayload((prev) => ({
                                    ...prev,
                                    weight,
                                  }));
                                } else {
                                  toast.error(
                                    "Please enter Length, Width, and Height first.",
                                  );
                                }
                              }}
                            >
                              <img src={AddMoreIcon} alt="add more icon" />
                            </Button>
                          </>
                        )}
                      </Box>
                      <TextField
                        sx={{ m: 1, width: "20ch" }}
                        label="Item Description"
                        id="outlined-size-small"
                        name="description"
                        value={newPackage.description}
                        size="small"
                        onChange={(e) => handleAddChange(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "20ch" }}
                        label="Item Quantity"
                        id="outlined-size-small"
                        name="quantity"
                        value={newPackage.quantity}
                        size="small"
                        type="number"
                        onChange={(e) => handleAddChange(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "20ch" }}
                        label="Item Weight"
                        id="outlined-size-small"
                        name="weight"
                        value={newPackage.weight}
                        size="small"
                        type="number"
                        disabled={packagingType === "dimensional"}
                        onChange={(e) => handleAddChange(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "20ch" }}
                        label="Item Value"
                        id="outlined-size-small"
                        name="unitOfPrice"
                        value={newPackage.unitOfPrice}
                        size="small"
                        type="number"
                        onChange={(e) => handleAddChange(e)}
                      />
                      <Button
                        style={{ textTransform: "capitalize", fontWeight: "700" }}
                        variant="contained"
                        color="primary"
                        onClick={() => handleAdditionalPackage()}
                      >
                        Add new Package
                      </Button>
                      {additionalPackage.length > 0 &&
                        additionalPackage.map((item, itemIndex) => (
                          <Box
                            sx={{ marginTop: 1, width: "100ch" }}
                            style={{
                              paddingHorizontal: 24,
                              backgroundColor: "#E4EAEF",
                              paddingVertical: 5,
                              borderRadius: 4,
                              marginBottom: 5,
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                            id={"Box" + itemIndex}
                            key={itemIndex}
                          >
                            <span
                              style={{
                                fontSize: 18,
                                paddingTop: 5,
                                paddingLeft: 20,
                              }}
                            >
                              {item.description}({item.unitOfPrice})
                            </span>
                            {itemIndex === additionalPackage.length - 1 && (
                              <Button
                                onClick={() => removeAdditionalPackage(itemIndex)}
                              >
                                Remove
                              </Button>
                            )}
                          </Box>
                        ))}
                    </Box>
                    <div className="">
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Number of package"
                        id="outlined-size-small"
                        name="unit"
                        value={calculatePricePayload.unit}
                        size="small"
                        onChange={(e) => handleUnitChange(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Weight"
                        id="outlined-size-small"
                        name="unitWeight"
                        value={calculatePricePayload.unitWeight}
                        size="small"
                        onChange={(e) => handleWeightChange(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Order No"
                        id="outlined-size-small"
                        name="flyerNo"
                        value={calculatePricePayload.flyerNo}
                        size="small"
                        onChange={(e) => handleInputChange(e)}
                      />
                      <TextField
                        fullWidth
                        sx={{ m: 1 }}
                        label="Item Description"
                        id="outlined-size-small"
                        name="description"
                        value={calculatePricePayload.description}
                        size="small"
                        onChange={(e) => handleInputChange(e)}
                      />

                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Declared Value (Naira)"
                        id="outlined-size-small"
                        name="declaredValue"
                        value={calculatePricePayload.declaredValue}
                        disabled
                        size="small"
                        type="number"
                        onChange={(e) => handleInputChange(e)}
                      />
                      <FormControl sx={{ m: 1, width: "50ch" }} size="small">
                        <InputLabel id="insurance-label">Insurance?</InputLabel>
                        <Select
                          labelId="insurance-label"
                          id="insurance-select"
                          name="insured"
                          value={calculatePricePayload.insured}
                          label="Insurance?"
                          onChange={(e) => handleSelectChange(e)}
                        >
                          <MenuItem value={null}>
                            <em>-- Select --</em>
                          </MenuItem>
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Total Quantity"
                        id="outlined-size-small"
                        name="unit"
                        value={calculatePricePayload.unit}
                        size="small"
                        disabled
                        onChange={(e) => handleInputChange(e)}
                      />
                      <TextField
                        sx={{ m: 1, width: "50ch" }}
                        label="Total Weight"
                        name="weight"
                        value={calculatePricePayload.weight}
                        id="outlined-size-small"
                        size="small"
                        disabled
                        onChange={(e) => handleInputChange(e)}
                      />
                      <Box>
                        <FormLabel id="cash-on-delivery-label">
                          Would you like the rider to collect any fee upon
                          delivery?
                        </FormLabel>
                        <RadioGroup
                          aria-labelledby="cash-on-delivery-label"
                          name="controlled-radio-buttons-group"
                          value={cashOption}
                          row
                          onChange={(e) => setCashOption(e.target.value)}
                        >
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </RadioGroup>
                        <Box
                          style={{ marginTop: "20px" }}
                          sx={{
                            width: 500,
                            maxWidth: "100%",
                          }}
                        >
                          {cashOption === "yes" ? (
                            <TextField
                              fullWidth
                              label="Amount"
                              name="cashonDelivery"
                              size="small"
                              value={calculatePricePayload.cashonDelivery}
                              id="fullWidth"
                              onChange={(e) => handleInputChange(e)}
                            />
                          ) : (
                            <> </>
                          )}
                        </Box>
                      </Box>
                    </div>
                  </Box>
                </CardContent>
              </Card>
              <Box
                sx={{
                  marginTop: "12px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {isCalculating ? (
                  <Button
                    style={{
                      textTransform: "capitalize",
                      fontWeight: "700",
                      border: "none",
                    }}
                    variant="outlined"
                    color="primary"
                  >
                    <CircularProgress />
                  </Button>
                ) : (
                  <Button
                    style={{ textTransform: "capitalize", fontWeight: "700" }}
                    variant="contained"
                    color="primary"
                    onClick={() => handlePriceCalculate()}
                  >
                    Continue
                  </Button>
                )}
              </Box>
            </>
          )}
        </Container>

        <div name="Payment summary">
          <Dialog
            maxWidth={"xs"}
            open={openSummary}
            onClose={handleSummaryClose}
          >
            <Box
              style={{ marginTop: "10px", marginBottom: "10px" }}
              sx={{
                maxWidth: "auto",
                display: "flex",
              }}
            >
              <Button style={{}} onClick={handleSummaryClose} color="error">
                <KeyboardBackspaceIcon />
              </Button>
              <DialogTitle style={{ paddingLeft: "0" }}>
                Payment Information
              </DialogTitle>
            </Box>
            <Box
              style={{
                paddingLeft: "0",
                paddingRight: "0",
                borderTop: "1px solid red",
                borderBottom: "1px solid red",
              }}
              sx={{
                borderTop: "1px solid error",
              }}
            >
              <div style={{ textAlign: "center", padding: "8px" }}>
                <p className="mb-1" style={{ fontSize: "12px" }}>
                  Amount
                </p>
                <p
                  className="mb-1"
                  style={{ fontSize: "16px", fontWeight: "700" }}
                >
                  {isAmountChanged && (
                    <span style={strikeThrough}>
                      {formatMoney(oldPayment?.totalAmount)}
                    </span>
                  )}
                  {formatMoney(hasNewPrice ? currentAmount : oldAmount)}
                </p>
                <span style={{ fontSize: "10px" }}>
                  {new Date().toDateString()}
                </span>
              </div>
            </Box>
            <DialogContent>
              <Box>
                {renderPriceLine(
                  "Onforwarding Fee",
                  oldPayment?.onforwardingCharge,
                  newPayment?.onforwardingCharge,
                )}
                {renderPriceLine(
                  "Insurance Charge",
                  oldPayment?.insuranceValue,
                  newPayment?.insuranceValue,
                )}
                {renderPriceLine(
                  "Service Charge",
                  oldPayment?.servicePrice,
                  newPayment?.servicePrice,
                )}
                {renderPriceLine(
                  "Discount",
                  oldPayment?.discount,
                  newPayment?.discount,
                )}
                {renderPriceLine("VAT", oldPayment?.vat, newPayment?.vat)}
              </Box>
            </DialogContent>
            <DialogActions>
              {isUpdatingShipment ? (
                <Button
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "700",
                    border: "none",
                  }}
                  variant="outlined"
                  color="primary"
                >
                  <CircularProgress />
                </Button>
              ) : (
                <Button
                  style={{ textTransform: "capitalize", fontWeight: "700" }}
                  variant="contained"
                  color="primary"
                  onClick={() => handleSave()}
                >
                  Save
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </>
  );
};

export default PackageScheduleEditPage;
